import {Tabs} from 'antd';
import type {ReactNode} from 'react';

import {Locale} from '../../../../../../provider/locale/locale';
import * as styles from '../reviews-filter.scss';

type PropsType = {
    origin: ReactNode;
    periodPickerActiveTab: string;
    onPeriodPickerTabChange: (activeKey: string) => void;
};

export function ReviewsFilterPeriodPickerPanel(props: PropsType): JSX.Element {
    const {origin, periodPickerActiveTab, onPeriodPickerTabChange} = props;

    return (
        <div className={styles.ReviewsFilter_periodDropdown}>
            <Tabs
                activeKey={periodPickerActiveTab}
                className={styles.ReviewsFilter_periodTabs}
                items={[
                    {
                        key: 'publication',
                        label: <Locale stringKey="REVIEWS__FILTER__TAB__PUBLICATION_DATE" />,
                        children: origin,
                    },
                    {
                        key: 'collection',
                        label: <Locale stringKey="REVIEWS__FILTER__TAB__COLLECTION_DATE" />,
                        children: origin,
                    },
                ]}
                onChange={onPeriodPickerTabChange}
            />
        </div>
    );
}
